import {
  InvalidConfigError,
  MessageFormatError,
  MissingDataError,
  MissingTranslationError,
  UnsupportedFormatterError,
} from 'react-intl';
import type { FormatError } from 'intl-messageformat';
import { ActionType, ComponentType, logEvent } from '@cbhq/client-analytics';

export type IntlError =
  | MissingTranslationError
  | MessageFormatError
  | MissingDataError
  | InvalidConfigError
  | UnsupportedFormatterError
  | FormatError;

const reportedKeys: Record<string, boolean> = {};

export function logI18nMissingTranslation(err: IntlError): void {
  const message = err?.message ?? '';

  const regexForExtraction = /Missing message: "(?<messageKey>.*)" for locale "(?<locale>.*)"/;

  const extraction = message.match(regexForExtraction);

  if (!extraction) {
    logEvent('i18n_unexpected_error', {
      loggingId: '5d3c2669-a4bb-4b10-b812-2eef67a252af',
      componentType: ComponentType.text,
      action: ActionType.measurement,
      errorCode: err.code,
      errorName: err.name,
      errorMessage: err.message,
    });
    return;
  }

  const { messageKey, locale } = extraction.groups ?? {};

  if (reportedKeys[messageKey]) {
    return;
  }

  if (locale !== 'en') {
    reportedKeys[messageKey] = true;

    logEvent('i18n_missing_translation', {
      loggingId: 'e8799326-b59f-4f63-877c-1e42072cc402',
      componentType: ComponentType.text,
      action: ActionType.render,
      language: locale,
      key: messageKey,
    });
  }
}
